import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';

import useBatchFilterValue from './hooks/useBatchFilterValue';
import useBatchOptionsQuery from './hooks/useBatchOptionsQuery';
import useUserFilterValue from './hooks/useUserFilterValue';
import useUserOptionsQuery from './hooks/useUserOptionsQuery';
import BatchFilterItem from './BatchFilterItem';
import UserFilterItem from './UserFilterItem';

export const UserEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useUserOptionsQuery,
  useFilterValues: useUserFilterValue,
  itemRenderer: ({ option, isSelected }) => (
    <UserFilterItem isSelected={isSelected} option={option} />
  ),
};

export const BatchEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useBatchOptionsQuery,
  useFilterValues: useBatchFilterValue,
  itemRenderer: ({ option, isSelected }) => (
    <BatchFilterItem isSelected={isSelected} option={option} />
  ),
};
